import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ph from './locales/ph.js'
import en from './locales/en.js'
import id from './locales/id.js'
import { LANGUAGE } from '@/common/constants.js'

Vue.use(VueI18n)

const messages = {
  [LANGUAGE.ph]: {
    ...ph
  },
  [LANGUAGE.en]: {
    ...en
  },
  [LANGUAGE.id]: {
    ...id
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || LANGUAGE.id,
  fallbackLocale: LANGUAGE.en,
  messages
})

export default i18n
